import { GPGKey, GPGKeyResponse, GPGKeyStatus } from './types';

export const convertToGPGKey = (data: GPGKeyResponse): GPGKey => ({
  id: data.id,
  keyId: data.key_id,
  fingerprint: data.fingerprint,
  publicKey: data.public_key,
  keyName: data.key_name,
  keyEmail: data.key_email,
  status: data.status as GPGKeyStatus,
  expiresAt: data.expires_at,
  createdAt: data.created_at,
  lastUsedAt: data.last_used_at,
  isActive: data.is_active,
  isExpired: data.is_expired,
});
